import moment from "moment/moment";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box, Stack, Typography } from "@mzc-pdc/ui";
import theme from "@styles/theme";
import StatusText from "@components_v2/status/status-text";
import StatusBadge from "@components_v2/status-badge/status-badge";

const AutomaticArchivedDateLabel = ({ date, ...props }) => {
    const { t } = useTranslation();
    const archivedTime = date ? moment.utc(date) : null;
    const duration = archivedTime ? parseInt(moment.duration(archivedTime.diff(moment())).asDays()) + 1 : 0;

    const durationLabel = useMemo(() => {
        if (duration <= 0) return "";
        else return `(${duration}${t("common::label::days left", "days left")})`;
    }, []);

    return (
        <React.Fragment>
            <Stack direction="row" alignItems="center">
                {props.hasOwnProperty("status") && (
                    <Box sx={{ pr: 1.5 }}>
                        <StatusBadge status={props.status ? "ACTIVE" : "INACTIVE"} showText={true} />
                    </Box>
                )}
                {archivedTime && (
                    <Typography>
                        {`${archivedTime.format("YYYY-MM-DD")} `}
                        <Typography color={theme.palette.warning.main}>{durationLabel}</Typography>
                    </Typography>
                )}
            </Stack>
        </React.Fragment>
    );
};
export default AutomaticArchivedDateLabel;
